module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"AQPS":"AQPS","DSA":"DEMI SANG ARABE","PS":"PUR-SANG","AR":"ARABE","AA":"ANGLO-ARABE","DS":"DEMI SANG","TE":"Trotteur étranger","TF":"Trotteur français"}}')
  delete Component.options._Ctor
}
